import { useState, useEffect } from "react";

const CardTemplate = ({ stepId, currentStep, body, extraButtonComponet = null }) => {
    const [isCollapse, setIsCollapse] = useState(currentStep >= stepId ? true : false);

    // Update isCollapse whenever currentStep or stepId changes
    useEffect(() => {
        setIsCollapse(currentStep >= stepId ? true : false);
    }, [currentStep, stepId]);

    const handleCollapse = () => setIsCollapse(!isCollapse);

    const handleTitle = () => {
        switch (stepId) {
            case 1:
                return "SET UP YOUR PROFILE";
            case 4:
                return "PROFILE PHOTO";
            case 5:
                return "PERSONAL INFORMATION";
            case 6:
                return "SKILL SET";
            case 7:
                return "UPLOADED CERTIFICATES";
            default:
                return "UPLOADED YOUR PERSONAL DOCUMENTS";
        }
    };

    return (
        <div className="card card-body mt-3" style={{ border: stepId === (currentStep + 1) ? '2px solid #55AE59' : 'none' }}>
            <div className="card-header d-flex justify-content-between align-items-center" style={{ paddingTop: '0.5rem', paddingBottom: '0.5rem' }}>
                <h5 className="mb-0">{handleTitle()}</h5>
                <div className="d-flex align-items-center gap-3">
                    {(extraButtonComponet && isCollapse === false) && (
                        <div>
                            {extraButtonComponet}
                        </div>
                    )}
                    {currentStep >= stepId && (
                        <i className="material-icons me-2" style={{ color: 'green', fontSize: '25px' }}>
                            check_box
                        </i>
                    )}
                    <button
                        className="btn btn-icon-only btn-rounded btn-outline-secondary btn-sm d-flex align-items-center justify-content-center"
                        style={{ marginBottom: 0 }}
                        onClick={handleCollapse}
                    >
                        <i className="material-icons text-lg">{isCollapse ? 'expand_less' : 'expand_more'}</i>
                    </button>
                </div>
            </div>
            <div className="card-body pt-0" style={{ display: isCollapse ? 'none' : 'block' }}>
                {body}
            </div>
        </div>
    );
};

export default CardTemplate;